
import TranResourcesApi from './src/Tranresources'
import ErrorLogApi from './src/ErrorLogApi'
import * as AppServerLogApi from './src/AppServerLogApi'


let apis = {
   TranResourcesApi,
   ErrorLogApi,
   AppServerLogApi
};

export default apis;
